import React, {useState, useEffect} from 'react';
import { InformationCard } from './informationCard';
import {sendRequest} from '../../../supplementary_components/requests';
import { LoadingIcon } from '../../../supplementary_components/loading_icon';
import { OverviewCard } from './overViewCard';
import { NoteManagingComponent, convertNotesToArray } from '../../notes/noteManagingComponent';
import styles from './itemPage.module.scss';


export const ItemPage = ({conf, identifier})=> {
    let pageObject = conf.pageConf;
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [updateAvailable, setUpdateAvailable] = useState(true);
    const _seData = (data) => {
        
        setUpdateAvailable(false);
        setData(data)
    }
    const requestReload = () => {
        setUpdateAvailable(true);
    }
    useEffect(() => {
        if(updateAvailable){
            setError(null);
            const controller = new AbortController();
            const signal = controller.signal;
            sendRequest('GET', pageObject.getLink+identifier, signal, _seData, setError, null);
            return () => {
                // cancel the request before component unmounts
                controller.abort();
            };
        }
        // eslint-disable-next-line
    }, [])
    
    
    if (error !== null) return <div className='errorMessage'>Something went wrong</div>
    if(pageObject === null || data === null) return <LoadingIcon state={true} height={'10rem'} />;
    pageObject.setData(data);
    return <div className={styles.wrapper} style={{ overflow: 'hidden', gridTemplateColumns: pageObject.columnProportions }}> 
        <InformationCard  object={pageObject} 
            setData={(val)=>{
                setUpdateAvailable(true);
                _seData(val)
            }} 
        /> 
        <OverviewCard object={pageObject} 
            setData={(val)=>{
                setUpdateAvailable(true);
                _seData(val)
            }}   
        />
        <NoteManagingComponent notesArray={convertNotesToArray(pageObject.notes)} category={conf.category} itemId={pageObject.id} requestReload={requestReload}  />
    </div>
}